module.exports = __webpack_public_path__ + "img/ArgCroacia5.0db059b9.jpg";